import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { commentaryTabs } from "@/mocks/media";

export default function Commentary() {
  const [active, setActive] = useState(commentaryTabs[0].id);
  const current = commentaryTabs.find((tab) => tab.id === active) ?? commentaryTabs[0];

  return (
    <section id="commentary" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Deep Dive"
              title="深度解说：喜剧外壳下真正在讲什么"
              desc="很多观众把它当消遣片看完就结束，其实影片在主题、人物和时代背景上都埋了可讨论的空间。下面从三个角度逐层拆解。"
            />
          </Reveal>

          <div className="mt-10 flex flex-wrap gap-2 p-1 rounded-full bg-background-100 border border-background-200 w-fit max-w-full">
            {commentaryTabs.map((tab) => {
              const isActive = tab.id === active;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActive(tab.id)}
                  className={`inline-flex items-center gap-2 px-4 md:px-5 py-2.5 rounded-full font-label text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-primary-600 hover:bg-primary-50"
                  }`}
                >
                  <i className={`${tab.icon} text-base`} />
                  {tab.label}
                </button>
              );
            })}
          </div>

          <div className="mt-6 md:mt-8 rounded-lg bg-background-100 border border-background-200 p-6 md:p-9">
            <p className="text-sm md:text-base leading-relaxed text-foreground-700 italic border-l-2 border-accent-500 pl-4">
              {current.intro}
            </p>

            <div className="mt-7 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {current.points.map((point, index) => (
                <div key={point.heading} className="flex flex-col">
                  <span className="font-heading text-3xl font-bold text-primary-200 leading-none">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950">
                    {point.heading}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                    {point.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}